import styled, { css } from 'styled-components';
import { rem } from 'polished';

const StyledPayrrollIncidence = styled.div`
  max-width: ${rem('600px')};
  margin-top: ${rem('37px')};

  .form-success,
  .form-error {
    display: flex;
    align-items: center;
  }
  .payrroll-loading {
    clear: right;
  }
`;

const StyledPayrrollMsj = styled.div`
  ${props =>
    props.sent &&
    !props.loading &&
    css`
      display: flex;
      justify-content: space-between;
    `}
`;

export { StyledPayrrollIncidence, StyledPayrrollMsj };
